import React, { useState } from "react";
import { Link } from "react-router-dom";
import { productRepo } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { EmptyState, baht, useAsync } from "../../components/ui";

export default function Store() {
  const { orgId } = useApp();
  const { tx } = useI18n();
  const [search, setSearch] = useState("");
  const { data: products } = useAsync(() => productRepo.all(orgId, (row) => row.isActive), [orgId], []);

  const filtered = (products || []).filter((product) => product.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <>
      <input className="input-crm u-mb-16" placeholder={tx("ค้นหาสินค้า/บริการ", "Search products/services")} value={search} onChange={(e) => setSearch(e.target.value)} />

      {filtered.length === 0 ? (
        <EmptyState text={tx("ไม่พบรายการที่ค้นหา", "No results")} />
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 14 }}>
          {filtered.map((product) => (
            <Link key={product.id} to={`/app/store/${product.id}`} className="card-crm" style={{ color: "inherit" }}>
              <div style={{ aspectRatio: "16/10", background: "linear-gradient(135deg, var(--c-indigo-500), var(--c-violet))", borderRadius: 10, marginBottom: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28 }}>
                🛍️
              </div>
              <div className="u-strong u-fs-14">{product.name}</div>
              <div className="u-fs-12 u-muted u-mb-8">{product.category}</div>
              <div className="u-strong u-indigo u-fs-18">{baht(product.price, 0)}</div>
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
